export default function (data) {
  var self = this;
  self.id = data.id;
  self.title = data.title;
  self.caption = data.caption;
  self.media_item = data.media_item;
  self.order = data.order;
  self.editing = data.editing;

  self.domId = ko.computed(function() {
    if (self.id) {
      return 'project_item_' + self.id();
    }
    else {
      if (self.media_item) {
        return self.media_item.item_class() + '_' + self.media_item.id();
      } else {
        return self.media_item_type() + '_' + self.media_item_id();
      }
    }
  });

  self.handleMissingThumb = function() {
    self.media_item.file.thumb(null);
  };

  self.placeholderImage = ko.computed(function() {
    return Kadenze.FileTypeMapping.getPlaceholderImage(self.media_item.type());
  });

  self.bgPlaceholderImageUrl = ko.computed(function() {
    return 'url(' + self.placeholderImage() + ')';
  });

  self.toggleEditing = function() {
    var $row = $('#' + self.domId());
    var $editRow = $('.display-table__edit_row', $row).first();
    $editRow.collapse('toggle');
    self.editing(!self.editing());
  };

  self.streamable = ko.computed(function() {
    return (typeof self.media_item.meta.streamable === 'function' && self.media_item.meta.streamable());
  });

  self.previewable = ko.computed(function() {
    return (typeof self.media_item.meta.previewable === 'function' && self.media_item.meta.previewable());
  });

  self.play = function() {
    console.log('Play:', self.media_item );
    Kadenze.MediaFileActions.play(ko.mapping.toJS(self.media_item));
  };

  self.queue = function() {
    Kadenze.MediaFileActions.queue(ko.mapping.toJS(self.media_item));
  };

  self.downloadLink = ko.computed(function() {
    return self.media_item.download_path();
  });

  self.preview = function() {
    Kadenze.MediaFileActions.preview(ko.mapping.toJS(self.media_item));
  };

  return self;
}

